module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jhnRzV/images/cover.jpg?1685327424356",
      "alt": "This image is the cover for the book The Lawyer Under the Tree, 2013 Advent Calendar - Heartwarming"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Lawyer Under the Tree, 2013 Advent Calendar - Heartwarming\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Christmas parties aren't Travis Buckley’s thing. He’s far too cynical and set in his ways. Too bad his bosses don't care what he wants. Travis had better lawyer up and make the firm proud by contributing to a charity auction giving out dates with gorgeous men. It’s not really a hardship, except Travis might just buy a bit more than he bargained for.")]), _vm._v(" "), _c('p', [_vm._v("Happy-go-lucky Cameron Ward runs the charity and has a lawyer for a brother, so he knows all about the secrets underneath those staid personas. This year, with a little help from his brother's firm, Cameron's setting out to be the crown jewel of the charity auction. Of course, every crown jewel needs a king—and Cameron knows exactly who he wants.")]), _c('p', [_c('i', [_vm._v("A story from the Dreamspinner Press 2013 Advent Calendar package \"Heartwarming\".")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Meg Harding\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0